<template>
  <div class="inactive">
    <div class="inactive__container">
      <img class="inactive__container__icon" src="@/assets/junior.png" />
      <div class="inactive__container__content">
        <h1>Oooops!</h1>
        <p v-html="$t('inactive.message')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import windowStore from '@/store/modules/window.store'

export default {
  name: 'inactive',
  beforeRouteEnter(to, from, next) {
    if (windowStore.state.countryCode === 'BR') {
      return next({ name: 'checkout' })
    }

    next()
  }
}
</script>

<style lang="scss" scoped>
.inactive {
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 15%;
    font-size: 1rem;
    min-height: calc(100vh - 100px);

    &__icon {
      left: 40px;
      height: 240px;
      width: auto;
      object-fit: contain;
      @media screen and (min-width: 641px) {
        height: 300px;
      }
    }
    &__content {
      text-align: center;

      & > h1 {
        font-size: 5em;
        font-weight: 900;
        margin-top: 0;
        margin-bottom: 12px;
        color: #525f7f;
      }

      & > p {
        font-size: 2em;
        font-weight: 500;
        line-height: 1.2;
        max-width: 600px;
        margin: 0 auto;

        & > span {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
